import { HIDE_MOBILE_APP_INTERNAL_ID } from 'common/constants';
import { useHideSomeExperiment } from './use-hide-some-experiment';

export function useHideMobileApp() {
  return useHideSomeExperiment(HIDE_MOBILE_APP_INTERNAL_ID);
}
